const {DateTime} = require("luxon");

const NAME_JOB = 'Job';
const NAME_GESUND = 'Gesundheit';
const NAME_ENTWICKLUNG = 'Entwicklung';
const NAME_SOZIAL = 'Soziales Umfeld';
const NAME_ICH = 'Ich';

const FREQ_DAILY = 'pro Tag';
const FREQ_WEEKLY = 'pro Woche';
const FREQ_MONTHLY = 'pro Monat';
const FREQ_QUARTERLY = 'pro Quartal';
const FREQ_HALFYEARLY = 'pro Halbjahr';
const FREQ_YEARLY = 'pro Jahr';

const INPUT_DAILY = 'täglich';
const INPUT_MO = 'am Montag';
const INPUT_DI = 'am Dienstag';
const INPUT_MI = 'am Mittwoch';
const INPUT_DO = 'am Donnerstag';
const INPUT_FR = 'am Freitag';
const INPUT_SA = 'am Samstag';
const INPUT_SO = 'am Sonntag';

const TYPE_NUMERIC = 'Anzahl';
const TYPE_BOOL = 'Ja/Nein';
const TYPE_CHANGE = 'Änderung';
const TYPE_SUMME = 'Summe';

const UNIT_MAL = 'mal';
const UNIT_SCHRITTE = 'Schritte';

// Job
const OPERATIVE_AUFGABEN = { name: 'Operative Aufgaben', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const ADMINISTRATION = { name: 'Administration', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const MEETINGS = { name: 'Meetings', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const EMAILS_TELEFONATE = { name: 'Emails, Telefonate', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const KUNDENGESPRAECHE = { name: 'Kundengespräche', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Organisation = { name: 'Organisation', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Mitarbeitergespraeche = { name: 'Mitarbeitergespräche', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Produktentwicklung = { name: 'Produktentwicklung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Strategiearbeit = { name: 'Strategiearbeit', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const ContentErstellung = { name: 'Content-Erstellung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Programmierung = { name: 'Programmierung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Praesentationserstellung = { name: 'Präsentationserstellung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Vortraege = { name: 'Vorträge', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Gespraechsvorbereitung = { name: 'Gesprächsvorbereitung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Buchhaltung = { name: 'Buchhaltung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Planung_langfristig = { name: 'Planung langfristig', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Planung_kurzfristig = { name: 'Planung kurzfristig', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const JobReflexion = { name: 'Reflexion', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };
const Weiterbildung = { name: 'Weiterbildung', type: TYPE_BOOL, freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft', };



// Gesundheit

const BEWEGUNG = {name: 'Bewegung',type: TYPE_BOOL,freq: FREQ_DAILY,unit: UNIT_MAL,target: 1,};
const Obst_essen = { name: 'Obst essen', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Gemüse_essen = { name: 'Gemüse essen', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const KeinFleisch = { name: 'Kein Fleisch', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Fasten = { name: '16/8 Methode (Fasten)', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Zahnseide_verwenden = { name: 'Zahnseide verwenden', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Kein_Alkohol = { name: 'kein_Alkohol', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const NICHT_RAUCHEN = {name: 'Keine Zigaretten',type: TYPE_BOOL,freq: FREQ_DAILY,unit: UNIT_MAL,target: 1,positiv: 'Verzichtet',negativ: 'Nicht verzichtet',};
const AusdauerTraining = { name: 'Ausdauer-Training', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Lieblingssport = { name: 'Lieblingssport', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Fahrrad = { name: 'Fahrrad/zu Fuß zur Arbeit', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Meditation = { name: 'Meditation', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Schritte = { name: 'Schritte', type: TYPE_NUMERIC, freq: FREQ_DAILY, unit:"Schritte", max:20000 };
const WASSER_TRINKEN = {name: 'Wasser trinken',type: TYPE_NUMERIC,freq: FREQ_DAILY,unit: 'Liter',max: 5,min: 0,target: 5,};




// ICH
const Gedanken = { name: 'Gedanken freien Lauf lassen', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const MEDITATION = {name: 'Meditation',type: TYPE_BOOL,freq: FREQ_DAILY,positiv: 'Geschafft',negativ: 'Nicht geschafft',};
const Reflexion = { name: 'Reflexion', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Lesen = { name: 'Lesen (Entspannung)', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Fernsehzeit= { name: 'Fernsehen', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const SozialNetworkzeit= { name: 'Zeit in Sozialen Netzwerken', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Hobby= { name: 'Hobby', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Zeit_fuer_mich= { name: 'Zeit für mich', type: TYPE_BOOL, freq: FREQ_WEEKLY, };
const Tagebuch= { name: 'Tagebuch schreiben', type: TYPE_BOOL, freq: FREQ_WEEKLY, };



// Soziales Umfeld
const Partner = { name: 'Zeit mit meinem Partner',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Kinder = { name: 'Zeit mit meinen Kindern',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Eltern = { name: 'Zeit mit meinen Eltern',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Familienzeit = { name: 'Familienzeit',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Spielzeit = { name: 'Spielzeit',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Familienausflüge = { name: 'Familienausflüge',type: FREQ_WEEKLY,freq: FREQ_DAILY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Freunde = { name: 'Freunde',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Vereine = { name: 'Vereine',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Kollegen = { name: 'Kollegen',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};



// Entwicklung
const KLAVIER = {name: 'Instrument spielen',type: TYPE_BOOL,freq: FREQ_DAILY,positiv: 'Geschafft',negativ: 'Nicht geschafft',};
const FACHLITERATUR = {name: 'Berufliche Bildung',type: TYPE_BOOL,freq: FREQ_WEEKLY,positiv: 'Geschafft',negativ: 'Nicht geschafft',};
const SPRACHE = {name: 'Sprache lernen',type: TYPE_NUMERIC,freq: FREQ_DAILY,unit: 'Lektionen',max: 10,min: 0,target: 1,};
const Faehigkeiten = { name: 'Erlernen neuer Fähigkeiten',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const DreissigTage = { name: '30-Tage-Challenge',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Podcasts = { name: 'Podcasts, News, Research',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Content = { name: 'Content zu verschiedenen Themen erarbeiten',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Erfolgsmatrix = { name: 'Erfolgsmatrix und Reflexion',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const DYL = { name: 'Dashboard your Life (Eingabe, Reflexion)',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const LangfristigesZiel = { name: 'An einem langfristigen Ziel arbeiten',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};
const Entwicklungstag = { name: 'Entwicklungstag',type: TYPE_BOOL,freq: FREQ_WEEKLY, positiv: 'Geschafft', negativ: 'Nicht geschafft',};

export default {
    TYPE_NUMERIC,
    TYPE_BOOL,
    TYPE_CHANGE,
    TYPE_SUMME,
    FREQ_WEEKLY,
    FREQ_DAILY,
    FREQ_MONTHLY,
    FREQ_QUARTERLY,
    FREQ_HALFYEARLY,
    FREQ_YEARLY,
    INPUT_DAILY,
    INPUT_MO,
    INPUT_DI,
    INPUT_MI,
    INPUT_DO,
    INPUT_FR,
    INPUT_SA,
    INPUT_SO,
    InputOptions: [INPUT_DAILY,INPUT_MO,INPUT_DI, INPUT_MI, INPUT_DO, INPUT_FR, INPUT_SA, INPUT_SO],
    Frequencies: [FREQ_DAILY, FREQ_WEEKLY],
    Types: [TYPE_NUMERIC, TYPE_BOOL, TYPE_CHANGE],
    Units: [UNIT_SCHRITTE, UNIT_MAL, 'Minuten', 'Stunden', 'kg', 'Meter', 'km', 'Stück', 'Liter'],
    //
    Activities: {
        'Job': [OPERATIVE_AUFGABEN, ADMINISTRATION, MEETINGS, EMAILS_TELEFONATE,KUNDENGESPRAECHE,Organisation,Mitarbeitergespraeche,Produktentwicklung,Strategiearbeit,
            ContentErstellung,Programmierung,Praesentationserstellung,Vortraege,Gespraechsvorbereitung,Buchhaltung,Planung_langfristig,Planung_kurzfristig,
            JobReflexion, Weiterbildung
        ],
        'Gesundheit': [BEWEGUNG,Obst_essen,KeinFleisch,Fasten,Zahnseide_verwenden,Kein_Alkohol,AusdauerTraining,Lieblingssport,Fahrrad,Meditation,Schritte,WASSER_TRINKEN],
        'Ich': [Gedanken,MEDITATION,Reflexion,Lesen,Fernsehzeit,SozialNetworkzeit,Hobby,Zeit_fuer_mich,Tagebuch],
        'Soziales Umfeld': [Partner, Kinder, Eltern, Familienzeit, Spielzeit, Familienausflüge, Freunde, Vereine, Kollegen],
        'Entwicklung': [KLAVIER, FACHLITERATUR, SPRACHE,Faehigkeiten, DreissigTage, Podcasts, Content, Erfolgsmatrix, DYL, LangfristigesZiel, Entwicklungstag],
    },
    filterActivitiesByDate(activities, dateTime) {
        return activities.filter(a=>{
            var added= DateTime.fromJSDate(new Date(a.addedDate || "2000-01-01")).setLocale("de").startOf('week');
            var deleted = DateTime.fromJSDate(new Date(a.deleteDate || "3000-01-01")).setLocale("de").startOf('week');
            var valid=added <= dateTime && deleted > dateTime;
            //console.log(a.name, added.toISODate(), deleted.toISODate(), dateTime.toISODate(), valid);
            return valid;
        });
    }
}